export default __webpack_public_path__ + "static/media/oauth.e55e5baa.svg";